import React from 'react';
import { observer } from 'mobx-react-lite';
import { toChoiceQuestionAnswerOrEmpty } from '../../../stores/QuestionStore';
import { DisplayMode } from '../../RenderForm';
import { EditCascadingDropdown } from './edit';
import { ViewCascadingDropdown } from './view';
export const CascadingDropdown = observer(({
  id,
  questionStore,
  displayMode
}) => {
  var _questionStore$issueF;
  const currentAnswer = toChoiceQuestionAnswerOrEmpty(questionStore.currentAnswer);
  const availableParentOptions = questionStore.availableOptions();
  const currentParentOption = availableParentOptions.find(option => {
    var _currentAnswer$choice, _currentAnswer$choice2;
    return option.value === (currentAnswer === null || currentAnswer === void 0 ? void 0 : (_currentAnswer$choice = currentAnswer.choices) === null || _currentAnswer$choice === void 0 ? void 0 : (_currentAnswer$choice2 = _currentAnswer$choice[0]) === null || _currentAnswer$choice2 === void 0 ? void 0 : _currentAnswer$choice2.split(':')[0]);
  });
  const availableChildOptions = currentParentOption === null || currentParentOption === void 0 ? void 0 : currentParentOption.children;
  const currentChildOption = availableChildOptions === null || availableChildOptions === void 0 ? void 0 : availableChildOptions.find(option => {
    var _currentAnswer$choice3;
    return option.value === (currentAnswer === null || currentAnswer === void 0 ? void 0 : (_currentAnswer$choice3 = currentAnswer.choices) === null || _currentAnswer$choice3 === void 0 ? void 0 : _currentAnswer$choice3[0].split(':')[1]);
  });
  const showEditComponent = displayMode === DisplayMode.Edit && !((_questionStore$issueF = questionStore.issueFieldData) !== null && _questionStore$issueF !== void 0 && _questionStore$issueF.readOnlyReason);
  if (showEditComponent) {
    var _questionStore$formQu, _questionStore$formQu2, _questionStore$formQu3;
    const onChange = value => {
      const selectedChoiceId = value === null || value === void 0 ? void 0 : value.value;
      const newChoiceIds = selectedChoiceId ? [selectedChoiceId] : [];
      questionStore.setAnswer({
        choices: newChoiceIds
      });
    };
    const onChangeChild = value => {
      const selectedChoiceId = value === null || value === void 0 ? void 0 : value.value;
      const newChoiceIds = selectedChoiceId ? [`${currentParentOption === null || currentParentOption === void 0 ? void 0 : currentParentOption.value}:${selectedChoiceId}`] : [];
      questionStore.setAnswer({
        choices: newChoiceIds
      });
    };
    return /*#__PURE__*/React.createElement(EditCascadingDropdown, {
      id: id,
      key: `${id}-${questionStore.dependentFieldChangedCount}`,
      options: availableParentOptions,
      value: currentParentOption,
      childOptions: availableChildOptions,
      childValue: currentChildOption,
      loading: questionStore.loading,
      onChange: onChange,
      onChangeChild: onChangeChild,
      isRequired: (_questionStore$formQu = questionStore.formQuestion) === null || _questionStore$formQu === void 0 ? void 0 : (_questionStore$formQu2 = _questionStore$formQu.validation) === null || _questionStore$formQu2 === void 0 ? void 0 : _questionStore$formQu2.rq,
      label: (_questionStore$formQu3 = questionStore.formQuestion) === null || _questionStore$formQu3 === void 0 ? void 0 : _questionStore$formQu3.label
    });
  }
  return /*#__PURE__*/React.createElement(ViewCascadingDropdown, {
    id: id,
    value: currentParentOption,
    childValue: currentChildOption,
    displayMode: displayMode
  });
});